import { useTranslation } from 'react-i18next';

const whyItems = [
  { key: 'whyUse1', icon: 'ri-money-dollar-circle-line' },
  { key: 'whyUse2', icon: 'ri-user-star-line' },
  { key: 'whyUse3', icon: 'ri-chat-check-line' },
  { key: 'whyUse4', icon: 'ri-shield-flash-line' },
  { key: 'whyUse5', icon: 'ri-fire-line' },
];

export default function WhyUseSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-10 md:mb-12 text-center">
          {t('whyUseTitle')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {whyItems.map((item) => (
            <div
              key={item.key}
              className="flex items-start gap-4 p-5 bg-white border border-background-200 rounded-lg"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-base`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 leading-relaxed">
                {t(item.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}